import { render } from "./GoBack.vue?vue&type=template&id=fdee09bc&ts=true"
import script from "./GoBack.vue?vue&type=script&lang=ts"
export * from "./GoBack.vue?vue&type=script&lang=ts"

import "./GoBack.vue?vue&type=style&index=0&id=fdee09bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__